import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Dropdown, Collapse } from 'react-bootstrap';
import Calendar from '../Calender/Calender';
import DateScroll from '../DateScroll/DateScroll';
import { BiSearchAlt } from 'react-icons/bi';
import { FaUserTie } from 'react-icons/fa';
import { BsTranslate } from 'react-icons/bs';
import { useLocation } from 'react-router';
import LeadForm from '../../../views/forms/LeadForm';
import LdcApi from '../../../LdcApis';
import { BsChevronDown } from 'react-icons/bs';
import Room from '../../../modules/Room';
import { useToasts } from "react-toast-notifications";

//import {AiFillHome} from 'react-icons/ai'
//import { Link } from 'react-router-dom';
const userInfo = JSON.parse(localStorage.getItem('user_info'));
const AptHeader = ({
  startDate,
  onChangeDate,
  onCalendar,
  handleAppointmentTableData,
  setSelectDoctorFromAppt,
  dateBySelect,
  allDoctor,
  selectDoctorFromAppt,
  headerData,
  getAllDoctors,
}) => {
    const { addToast } = useToasts();
  
  const location = useLocation();
  const [allService, setAllService] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [locationDate, setLocationDate] = useState('');
  const [loading, setLoading] = useState(false);

  const [showLead, setShowLead] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const [rolesList, setRolesList] = useState([]);
  const [roomList, setRoomList] = useState([]);

  const [showCAButton, setShowCAButton] = useState(false);
  const futureDoctors = allDoctor.filter((doc) => doc.hasFutureDates);
 const [pendingPayload, setPendingPayload] = useState(null);
  const pastDoctors = allDoctor.filter((doc) => !doc.hasFutureDates);
  const selectedDate = (selectDate) => {
    if (
      location?.state?.date === locationDate ||
      (location?.state?.date === undefined && locationDate === '')
    ) {
      onCalendar(selectDate);
    } else {
      onCalendar(location?.state?.date);
    }
  };
  useEffect(() => {
    if (headerData) {
      // Map roomId and roomName into a list
      const rooms = headerData.map((item) => ({
        roomId: item.roomId,
        roomName: item.roomName,
      }));
      const roles = headerData.map((item) => item.role);
      const hasCA = headerData.some((item) => item.hasClinicalAssistant);

      getRoomForChamber();

      setShowCAButton(hasCA);
      // setRoomList(rooms);
      setRolesList(roles);
    }
  }, [headerData]);
  useEffect(() => {
    setTimeout(() => {
      setLocationDate(location?.state?.date);
    }, 2000);
  }, [location]);

  const handleSelectDoctor = (e) => {
    setSelectDoctorFromAppt(e.target.value);
    setShowDropdown(false); // close after selecting doctor
  };

  useEffect(() => {
    LdcApi({
      method: 'GET',
      url: 'ServiceMaster/GetServiceMastesExcludedTest',
    })
      .then((res) => {
        //  if(response.data.status.isSuccess === true){
        setAllService(res?.data);
        // }
      })
      .catch((error) => {
        // callback({ status: error });
      });
  }, []);

  const getRoomForChamber = () => {
    Room.getAllRooms((response) => {
      console.log('response qwwqw', response);
      if (response?.status === 'success') {
        let filterRoom = response?.data.filter((itm) => {
          return itm.active;
        });

        const tempRoom = filterRoom?.map((item, idx) => {
          return {
            id: item.id,
            name: item.roomName,
          };
        });

        setRoomList(tempRoom);
      }
    });
  };

  // store payload for retry

  const handleSelect = (roomId) => {
    setSelectedOption(roomId);

    const plasticSurgeon = headerData?.find((item) =>
      item.role?.toLowerCase().includes('plastic surgeon')
    );

    const payload = {
      roomId: Number(roomId),
      chamberDate: plasticSurgeon?.chamberDate,
    };

    LdcApi({
      method: 'POST',
      url: 'Chamber/AddChamberForCA',
      data: payload,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data?.status?.isSuccess) {
          getAllDoctors(plasticSurgeon?.chamberDate);
          console.log('Chamber added successfully:', res.data);
        } else {
          console.warn('Failed:', res.data?.status?.errorMessage);

          if (
            res.data?.status?.errorMessage
              ?.toLowerCase()
              .includes('slot already booked')
          ) {
            setPendingPayload(payload); // save for retry
            setShowPopup(true); // open modal
          }
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  const submitRequest = () => {
    if (!pendingPayload) return;
    setLoading(true);

    const payloadWithOverride = {
      ...pendingPayload,
      roomAvailable: true,  
    };

    LdcApi({
      method: 'POST',
      url: 'Chamber/AddChamberForCA',
      data: payloadWithOverride,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data?.status?.isSuccess) {
          getAllDoctors(pendingPayload.chamberDate);
          addToast('Shift added successfully.', {
            appearance: 'success',
          });
           setLoading(false);
          console.log('Chamber confirmed with override:', res.data);
        } else {
          addToast(res.data?.status?.errorMessage, {
            appearance: 'error',
          });
          console.warn('Still failed:', res.data?.status?.errorMessage);
           setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error:', err);
         setLoading(false);
      })
      .finally(() => {
         setLoading(false);
        setShowPopup(false);
        setPendingPayload(null);
      });
  };

  const closeDeleteTaskPopup = () => {
    setShowPopup(false);
  };
  // const submitRequest = () => {
  //   const plasticSurgeon = headerData?.find((item) =>
  //     item.role?.toLowerCase().includes('plastic surgeon')
  //   );

  //   const payload = {
  //     roomId: Number(selectedOption),
  //     chamberDate: plasticSurgeon?.chamberDate,
  //     isAvailable: true,
  //   };

  //   LdcApi({
  //     method: 'POST',
  //     url: 'Chamber/AddChamberForCA',
  //     data: payload,
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   })
  //     .then((res) => {
  //       if (res.data?.status?.isSuccess) {
  //         getAllDoctors(plasticSurgeon?.chamberDate);
  //         console.log('Chamber confirmed with isAvailable:true:', res.data);
  //       } else {
  //         console.warn('Failed to confirm Clinic Assistant');
  //       }
  //     })
  //     .catch((err) => {
  //       console.error('Error:', err);
  //     })
  //     .finally(() => {
  //       setShowPopup(false);
  //     });
  // };

  return (
    <>
      <Row className='w-100'>
        <Col
          md={4}
          sm={12}
          style={{
            paddingLeft: '15px !important',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          {userInfo.userType !== 'D' && (
            <Dropdown
              className='doctor-dropdown'
              autoClose='outside'
              show={showDropdown}
              onToggle={(isOpen) => {
                setShowDropdown(isOpen);
                if (!isOpen) {
                  setOpen(false); // <-- close submenu when dropdown closes
                }
              }}
            >
              <Dropdown.Toggle
                variant='light'
                id='doctor-dropdown'
                className='shadow-sm d-flex justify-content-between align-items-center'
                style={{
                  width: '210px',
                  borderRadius: '.25rem',
                  border: '1px solid #ccc',
                  backgroundColor: '#BFBBBB',
                  color: '#495057',
                  height: '32px',
                  fontSize: '1rem',
                  textAlign: 'center',
                }}
              >
                <span>
                  {selectDoctorFromAppt
                    ? allDoctor.find(
                        (d) => String(d.id) === String(selectDoctorFromAppt)
                      )?.name
                    : 'Search for Doctor'}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  maxHeight: '540px',
                  overflowY: 'auto',
                  width: '210px',

                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  borderRadius: '.25rem',
                }}
                className='no-scrollbar'
              >
                {pastDoctors.length > 0 && (
                  <>
                    <div
                      onClick={() => setOpen(!open)}
                      aria-controls='collapse-past'
                      aria-expanded={open}
                      className='fw-semibold px-2 py-1 d-flex justify-content-between align-items-center'
                      style={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        color: '#333',
                      }}
                    >
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#212529',
                        }}
                      >
                        Past Shifts
                      </span>
                      <span
                        style={{
                          fontSize: '14px',
                          transition: 'transform 0.2s ease',
                          transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      >
                        <BsChevronDown />
                      </span>
                    </div>
                    <Dropdown.Divider />
                    <Collapse in={open}>
                      <div id='collapse-past'>
                        {pastDoctors.map((doc) => (
                          <Dropdown.Item
                            key={doc.id}
                            onClick={() =>
                              handleSelectDoctor({
                                target: { value: String(doc.id) },
                              })
                            }
                            className='py-2 custom-doctor-dropdown-item'
                            style={{ padding: '8px 10px' }}
                          >
                            {doc.name}
                          </Dropdown.Item>
                        ))}
                      </div>
                    </Collapse>
                    {open && <Dropdown.Divider />}
                  </>
                )}

                {futureDoctors.length > 0 && (
                  <>
                    <small
                      className='  px-2 py-2'
                      style={{ fontSize: '14px', fontWeight: '600' }}
                    >
                      Future Shifts
                    </small>
                    {futureDoctors.map((doc) => (
                      <Dropdown.Item
                        key={doc.id}
                        onClick={() =>
                          handleSelectDoctor({
                            target: { value: String(doc.id) },
                          })
                        }
                        className='py-2 custom-doctor-dropdown-item'
                        style={{ padding: '8px 10px' }}
                      >
                        {doc.name}
                      </Dropdown.Item>
                    ))}
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}

          {/* {
          userInfo.userType !== 'D' && <select onChange={handleSelectDoctor} value={selectDoctorFromAppt} className='form-control doctor-slot-select'
            style={{ width: "200px", backgroundColor: "#bfbbbb", marginBottom: "12px", height: "32px" }}>
            <option value="">Search for Doctor</option>
            {allDoctor.map((item) => {
              return (
                <option value={item.id}>{item.name}</option>
              )
            })}
          </select>
        } */}
          {/* <Button
          // className='mb-2'
          variant='outline-primary'
          onClick={() => {
            setShowLead(true);
          }}
          // disabled={viewOnly}
          style={{ marginBottom: '12px' }}
        >
          Add Lead
        </Button> */}
        </Col>
        <Col md={4} sm={12} className='d-flex justify-content-center px-0'>
          <div className=' p-0 m-0 w-70'>
            {/* <Calendar startDate={startDate} onChangeDate={onChangeDate} /> */}
            <DateScroll
              selectedDate={selectedDate}
              dateBySelect={dateBySelect}
            />
          </div>
        </Col>
        {!showCAButton &&
        rolesList.some((role) =>
          role?.toLowerCase().includes('plastic surgeon')
        ) ? (
          <Col
            md={4}
            sm={12}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Dropdown onSelect={handleSelect}>
              <Dropdown.Toggle
                as={Button}
                style={{
                  backgroundColor: '#e4ebf3ff',

                  border: '1px solid #c8cdd2ff',
                  borderRadius: '25px',
                  padding: '4px 16px',
                  fontSize: '14px',
                  fontWeight: '500',
                  // width: '180px'
                }}
                className='text-ca'
              >
                Add CA
              </Dropdown.Toggle>

              <Dropdown.Menu
                align='end'
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  padding: '4px 0',
                  minWidth: '180px',
                  // 🚀 this kills the white triangle
                  marginTop: '6px',
                }}
                className='no-arrow'
              >
                {roomList.map((room) => (
                  <Dropdown.Item
                    key={room.id}
                    eventKey={room.id}
                    style={{
                      fontSize: '14px',
                      padding: '8px 16px',
                    }}
                  >
                    {room.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        ) : null}
      </Row>
      <Modal show={showPopup}>
        <Modal.Body className=''>
          <div className='d-flex justify-content-between'>
            <h4 className='text-secondary ' style={{ fontWeight: '600' }}>
              WARNING!
            </h4>
          </div>
          <h6 className='mt-3'>
            This room is already in use today are you sure you wish to proceed?
          </h6>
          <div className='d-flex mt-4 justify-content-around'>
           <Button
  onClick={submitRequest}
  className="px-5"
  variant="success"
  disabled={loading} // prevent multiple clicks
>
  {loading ? (
    <span
      className="spinner-border spinner-border-sm text-light"
      role="status"
      aria-hidden="true"
    ></span>
  ) : (
    "Yes"
  )}
</Button>

            <Button
              onClick={closeDeleteTaskPopup}
              className='px-5 '
              variant='danger'
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showLead}
        centered
        size='lg'
        onHide={() => setShowLead(false)}
        style={{ paddingBottom: '20px' }}
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            Add Lead
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ display: 'flex', justifyContent: 'center', padding: '0px' }}
        >
          <LeadForm
            fetchData={() => {
              // console.log("H")
            }}
            setShowLead={setShowLead}
            allService={allService}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AptHeader;
